import { userService } from '../services';
import {
  BRAND_LOADING,
  CHANGE_BRAND_SEARCH,
  GET_BRAND_PRODUCTS,
  FAILED_BRAND_PRODUCTS,
  LOAD_MORE_BRANDS,
  BRAND_COMBINATION_LOADING,
  GET_BRAND_COMBINATION,
  FAILED_BRAND_COMBINATION,
} from '../config/actionTypes';
import qs from 'qs';

export const brandActions = {
  getBrandProducts,
  loadMoreBrands,
  changeBrandsSearch,
  getBrandCombination,
};

function loadMoreBrands(params) {
  return (dispatch) => {
    dispatch(requestLoader());
    return userService.PostInfo('/search', params).then(
      (result) => {
        dispatch(success(result));
        dispatch(successLoader());
      },
      () => {
        dispatch(failureLoader());
      }
    );
  };
  function requestLoader() {
    return { type: 'REQUEST' };
  }
  function successLoader() {
    return { type: 'SUCCESS' };
  }
  function failureLoader() {
    return { type: 'FAILURE' };
  }
  function success(result) {
    return { type: LOAD_MORE_BRANDS, result };
  }
}

function getBrandProducts(queryParams, urlParams, page) {
  let endpoint = '/brands/:uri_param';
  if (queryParams) {
    endpoint += '?' + qs.stringify(queryParams);
  }
  if (urlParams) {
    Object.keys(urlParams).forEach((k) => {
      endpoint = endpoint.replace(':' + k, urlParams[k]);
    });
  }
  return (dispatch) => {
    dispatch(brandLoading());
    userService.GetInfo(endpoint, '').then(
      (data) =>
        userService.PostInfo('/search', { brand: [data.uri_param], page: page }).then(
          (result) => {
            return dispatch(
              success({
                ...result,
                ...data,
              })
            );
          },
          (err) => dispatch(failed(err))
        ),
      (err) => dispatch(failed(err))
    );
  };
  function brandLoading() {
    return { type: BRAND_LOADING, loading: true };
  }
  function success(result) {
    return { type: GET_BRAND_PRODUCTS, result, loading: false };
  }
  function failed(error) {
    return { type: FAILED_BRAND_PRODUCTS, error };
  }
}

function changeBrandsSearch(data) {
  return (dispatch) => {
    dispatch(success(data));
  };
  function success(changeProduct) {
    return { type: CHANGE_BRAND_SEARCH, changeProduct };
  }
}

function getBrandCombination(queryParams, urlParams) {
  let endpoint = '/brands/combinations/:uri_param';
  if (queryParams) {
    endpoint += '?' + qs.stringify(queryParams);
  }
  if (urlParams) {
    Object.keys(urlParams).forEach((k) => {
      endpoint = endpoint.replace(':' + k, () => urlParams[k]);
    });
  }
  return (dispatch) => {
    dispatch(brandCombinationLoading());
    userService.GetInfo(endpoint, '').then(
      (data) => {
        dispatch(success(data));
      },
      (err) => {
        dispatch(failed(err));
      }
    );
  };
  function brandCombinationLoading() {
    return { type: BRAND_COMBINATION_LOADING, loading: true };
  }
  function success(result) {
    return { type: GET_BRAND_COMBINATION, result, loading: false };
  }
  function failed(error) {
    return { type: FAILED_BRAND_COMBINATION, error };
  }
}
